var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.showSubMenu
      ? _c(
          "div",
          { staticClass: "landing-page-menu-container faux-fixed" },
          _vm._l(_vm.pages, function(page) {
            return _c(
              "router-link",
              {
                key: page.title,
                staticClass: "landing-page-menu-button stay-black",
                class: { active: page.number == _vm.currentPage },
                attrs: { to: page.href }
              },
              [_vm._v("\n            " + _vm._s(page.title) + "\n        ")]
            )
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dad74ae0", { render: render, staticRenderFns: staticRenderFns })
  }
}